import { render } from "./footer_temp.vue?vue&type=template&id=db5f3720"
import script from "./footer_temp.vue?vue&type=script&lang=js"
export * from "./footer_temp.vue?vue&type=script&lang=js"

import "./footer_temp.vue?vue&type=style&index=0&id=db5f3720&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__